<template>
  <div
    :class="['player-bottom-contents', { 'z-index-default': isDefaultZIndex }]"
  >
    <div ref="nav" class="player-nav-layout">
      <ul>
        <li v-for="(tab, index) in tabs" :key="`bottom_tab_${index}`">
          <button
            type="button"
            :class="{ on: currentTab === tab.type }"
            @click.prevent="changeTab(tab)"
          >
            {{ tab.title }}
          </button>
        </li>
      </ul>
    </div>

    <!--    에피소드 (vod) -->
    <EpisodeContentList
      v-if="currentTab === 'episode'"
      :key="`vod-episode-list${componentKey}`"
      :content-info="contentInfo"
      :landing-info="landingInfo"
    />

    <!--    영화 시리즈 (movie) -->
    <MovieSeriesContentList
      v-else-if="currentTab === 'series'"
      :key="`movie_series_${componentKey}`"
      :content-info="contentInfo"
    />

    <!--    관련 영상 (vod|movie) -->
    <RelatedContentList
      v-else-if="currentTab === 'related'"
      :key="`related_list_${componentKey}`"
      :section="section"
      :content-info="contentInfo"
      :landing-info="landingInfo"
    />

    <!--    추천 (vod|movie) -->
    <RecommendCatalog
      v-else-if="currentTab === 'recommend'"
      :key="`추천탭__${section}`"
      :section="section"
      :content-info="contentInfo"
    />

    <!--    상세 정보 (vod|movie) -->
    <ContentsDetail
      v-show="currentTab === 'detail'"
      :key="`${section}_detail_${componentKey}`"
      :section="section"
      :content-info="contentInfo"
    />
  </div>
</template>
<script>
  import _ from 'lodash'
  import { MOVE_TO_DETAIL_TAB, DOWNLOAD_LAYOUT } from '@/common/resources/const'
  import EpisodeContentList from '@/components/player/tabs/episode/EpisodeContentList'
  import RelatedContentList from '@/components/player/tabs/related/RelatedContentList'
  import ContentsDetail from '@/components/player/tabs/info/ContentsDetail'
  import MovieSeriesContentList from '@/components/player/tabs/series/MovieSeriesContentList'
  import RecommendCatalog from '@/components/player/tabs/recommend/RecommendCatalog'

  export default {
    name: 'BottomTabContainer',
    components: {
      EpisodeContentList,
      RecommendCatalog,
      MovieSeriesContentList,
      RelatedContentList,
      ContentsDetail,
    },
    props: {
      contentInfo: {
        type: Object,
        default: () => ({}),
      },
      landingInfo: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        section: '', // vod movie live -
        currentTab: '',
        componentKey: 0,
        tabs: [],
        isDefaultZIndex: false,
      }
    },
    computed: {
      recommendTab() {
        return { type: 'recommend' }
      },
      movieRelatedTab() {
        const { countinfo: countInfo = {} } = this.contentInfo
        const hasRelatedVideo =
          Number(_.get(countInfo, 'typeP', '0')) +
            Number(_.get(countInfo, 'typeA', '0')) >
          0
        return hasRelatedVideo ? { type: 'related' } : null
      },
      seriesTab() {
        const { movieseriesid: movieSeriesId = '' } = this.contentInfo
        return movieSeriesId !== '' ? { type: 'series' } : null
      },
      detailTab() {
        return { type: 'detail' }
      },
      landingTab() {
        return _.get(this.landingInfo, 'landing_list.tab', [])
      },
    },
    created() {
      this.section = this.$route.meta?.section
      this.getTabs()
      this.$events.$on(DOWNLOAD_LAYOUT, (isOpen) => {
        this.isDefaultZIndex = isOpen
      })
    },
    mounted() {
      this.currentTab = _.get(this.tabs, '0.type', '')
      this.$events.$on(MOVE_TO_DETAIL_TAB, this.moveToDetailTab)
    },
    beforeDestroy() {
      this.$events.$off(MOVE_TO_DETAIL_TAB)
      this.$events.$off(DOWNLOAD_LAYOUT)
    },
    methods: {
      changeTab(tab) {
        this.currentTab = tab?.type || this.tabs[0]
        this.componentKey += 1
      },
      getTabTitle(tab) {
        const type = tab?.type || ''
        let title = ''
        switch (type) {
          case 'episode':
            title = '에피소드'
            break
          case 'related':
            title = '관련영상'
            break
          case 'recommend':
            title = '추천'
            break
          case 'series':
            title = '시리즈'
            break
          case 'detail':
            title = '상세정보'
        }
        return title
      },
      moveToDetailTab() {
        this.changeTab(this.detailTab)

        const tab = this.$refs.nav
        const headerOffset =
          document.querySelector('header > .header-container')?.offsetHeight ||
          74
        const tabPosition = tab?.getBoundingClientRect().top
        const offsetPosition = tabPosition + window.pageYOffset - headerOffset
        window.scrollTo({
          top: offsetPosition,
        })
      },
      getTabs() {
        let tabList = []
        switch (this.section) {
          case 'movie':
            tabList = [
              this.movieRelatedTab,
              this.seriesTab,
              this.recommendTab,
              this.detailTab,
            ]
            break
          case 'vod':
            tabList = [...this.landingTab, this.recommendTab, this.detailTab]
            break
        }
        tabList = tabList.filter((item) => item)
        tabList.map((tab) => {
          Object.assign(tab, { title: this.getTabTitle(tab) })
        })
        this.tabs = tabList
      },
    },
  }
</script>
<style scoped lang="scss">
  @import '@/assets/scss/import/_color.scss';
  .player-nav-layout {
    position: relative;
    overflow: hidden;
    margin: 0px 100px 40px;
    ul {
      width: 100%;
      border-bottom: 1px $neutral-40 solid;
      font-size: 0;
      li {
        display: inline-block;
        vertical-align: middle;
      }
      li + li {
        margin-left: 20px;
      }
      li button {
        display: inline-block;
        padding: 0 10px;
        border-bottom: 4px transparent solid;
        font-size: 18px;
        color: $neutral-80;
        line-height: 63px;
        text-align: center;
        cursor: pointer;
      }
      li button.on {
        border-bottom-color: $primary-10;
        color: #fff;
      }
    }
    & + div {
      position: relative;
      min-height: 550px;
    }
  }
</style>
